module.exports = __webpack_public_path__ + "static/media/learn-more.2fe1a7f9.svg";